<template>
  <div class="messageSignatures">
    <el-card shadow="never">
      <h3>短信签名</h3>
      <p>
        <span class="el-icon-warning-outline s1"></span>
        <span class="s2">短信签名用于阿里云申请，审核通过后即可新建短信模块。 <span style="color:#0C64BCFF;"> 操作指引>></span></span>
      </p>
      <div class="intbtn">
          <el-select placeholder="请选择活动区域" v-model="select" value="请选择状态">
           <el-option label="审核通过" value="1"></el-option>
         <el-option label="审核中" value="2"></el-option>
         <el-option label="审核不通过进行" value="3"></el-option>
        </el-select>
        <el-button icon="el-icon-plus" type="primary" round @click="$router.push({path:'/systemSetup/companySet',query:{target:5}})">新建签名</el-button>
      </div>
      <!-- 表格 -->
      <el-table
        :header-cell-style="{ background: '#F5F5F5', color: '#333333' }"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column prop="d1" label="签名名称" width="100">
        </el-table-column>
        <el-table-column prop="d2" label="签名用途"> </el-table-column>
    
        <el-table-column prop="d3" label="备注信息">
        </el-table-column>
            <el-table-column prop="d4" label="状态">
          <template slot-scope="scope">
              <span v-if="scope.row.d4 == '审核中'">{{
              scope.row.d4
            }}</span>
            <span v-if="scope.row.d4 == '审核通过'" class="colorBlur">{{
              scope.row.d4
            }}</span>
             <span v-if="scope.row.d4 == '审核不通过'" class="colorRed">{{
              scope.row.d4
            }} <i class="el-icon-warning" style="margin-left:2px;"></i></span>
          </template>
        </el-table-column>
        <el-table-column prop="d5" label="创建时间" >
        </el-table-column>
             <el-table-column prop="d6" label="操作" >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="$router.push({path:'/systemSetup/companySet',query:{target:4}})">详情</el-button>
            <el-button type="text" size="small" @click="remove">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="my-page"
        background
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="prev,pager,next,sizes,jumper"
        :total="70"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
       select:'请选择状态',
      tableData: [
        {
          d1: "短信签名名称",
          d2: "自有产品",
          d3: "备注文字内容",
          d4: "审核中",
          d5:'2018/03/05 11:02:05'
        },
        {
          d1: "短信签名名称",
          d2: "自有产品",
          d3: "哎呦不错哦",
          d4: "审核通过",
          d5:'2018/03/05 11:02:05'
        },
        {
          d1: "短信签名名称",
          d2: "自有产品",
          d3: "哎呦不错哦",
          d4: "审核不通过",
          d5:'2018/03/05 11:02:05'
        },
      ],
    };
  },
  methods:{
        remove(){
        this.$confirm('是否确定删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          roundButton:true,
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
    }
  }
};
</script>

<style lang='less'>
.messageSignatures {
  padding: 20px;
  h3 {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #33393f;
  }
  p {
    margin-left: 8px;
    box-sizing: border-box;
    padding-left: 13px;
    margin-top: 38px;
    margin-bottom: 26px;
    width: 100%;
    height: 38px;
    background: rgba(73, 116, 251, 0.112516388297081);
    border-radius: 4px 4px 4px 4px;
    line-height: 38px;
    .s1 {
      color: #258ef7;
    }
    .s2 {
      margin-left: 13px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #258ef7;
    }
  }
  .intbtn {
    display: flex;
    justify-content: space-between;
    .el-input__inner {
      width: 114px;
      height: 40px;
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #606266;
      padding-right: 0px;
    }
    .el-button {
      width: 114px;
      height: 36px;
      background: #2e6cf6;
      border-radius: 18px 18px 18px 18px;
    }
  }
  //表格样式
  .el-table {
    margin-top: 20px;
    .el-table__header tr,
    .el-table__header th {
      padding: 0;
      height: 43px;
    }
    border: none;
    .cell {
      text-align: center;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    .el-table__row {
      height: 52px;
    }
    .el-button {
      font-size: 12px;
    }
    .el-tag {
      width: 74px;
      height: 24px;
      line-height: 22px;
      border-radius: 12px;
      color: #3373fe;
      background: #e2edff;
      font-size: 12px;
    }
    .jy {
      background: rgba(224, 32, 32, 0.10000000149011612);
      color: #ff4343;
    }
  }
  //分页样式
  .my-page {
    margin-top: 15px;
    .el-pager li {
      background-color: #fff;
    }
    .btn-prev {
      background-color: #fff;
    }
    .btn-next {
      background-color: #fff;
    }
    .el-pagination__jump {
      margin-left: 10px;
    }
  }
  //公共样式
  .colorBlur {
    color: #327effff;
  }
  .colorRed {
    color: #E02020FF;
  }
}
</style>